export default ({ user }) => user.permissions.can_access_backroom_comment;
